export class TeamUser {
  Id: number;
  RecordId: number;
  TeamId: number;
  UserId: number;
  CreatedBy: number;
  CreatedDate: string;
  ModifiedBy?: number;
  ModifiedDate?: string;
  IsDeleted: boolean;

  constructor(obj?: Partial<TeamUser>) {
    if (obj) {
      Object.assign(this, obj);
    } else {
      throw Error('Object cannot be null');
    }
  }
}
